import React, { useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import MemberCancelReasonForm from '../../../components/forms/MemberCancelReasonForm';
import { useMemberCancelReasonById, useUpdateMemberCancelReason } from '../../../hooks/useMemberCancelReasonApi';
import { useNavigate, useParams } from 'react-router-dom';
import Card from '../../../components/common/Card';
import { MemberCancelReasonDTO } from '../../../services/apiClient';

const MemberCancelReasonEdit: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { data: entityData, isLoading } = useMemberCancelReasonById(id);
  const updateMutation = useUpdateMemberCancelReason();
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Member Cancel Reasons', href: '/admin/membercancelreasons' },
    { label: 'Edit', href: '#' },
  ];

  const handleSubmit = async (data: any) => {
    try {
      setIsSubmitting(true);
      await updateMutation.mutateAsync({ id: id!, data });
      navigate('/admin/membercancelreasons');
    } catch (error) {
      console.error('Error updating MemberCancelReason:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/membercancelreasons"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Settings.MemberCancelReason.Edit'
    >
        {entityData ? (
          <MemberCancelReasonForm
            initialValues={entityData}
            onSubmit={handleSubmit}
            onCancel={() => navigate('/admin/membercancelreasons')}
          />
        ) : (
          <p>Loading...</p>
        )}
    </AdminLayout>
  );
};

export default MemberCancelReasonEdit;